ociosidade();

let titleInterval;

function ociosidade() {
    var tempoDeEspera = 30000;
    var timeout = setTimeout(inativo, tempoDeEspera);

    function actividade(e) {
        clearInterval(timeout);
        timeout = setTimeout(inativo, tempoDeEspera);
        clearInterval(titleInterval);
        document.title = "Voanet";
    }

    function inativo() {
        const showedLastTimeIdleness = localStorage.getItem(
            "showedLastTimeIdleness"
        );
        const oneDayTime = 24 * 60 * 60 * 1000;

        if (
            !showedLastTimeIdleness ||
            Date.now() - showedLastTimeIdleness > oneDayTime
        ) {
            document
                .querySelector("#modal-abandono")
                .classList.add("show");
            document.getElementById("me-ligue_lead_source").value =
                "POPUP INATIVIDADE";

            const originalTitle = document.title;
            let titleAlternativo = "Ainda Está Aí?";
            let titleAtual = originalTitle;
            titleInterval = setInterval(() => {
                document.title =
                    titleAtual === originalTitle
                        ? titleAlternativo
                        : originalTitle;
                titleAtual = document.title;
            }, 1000); // Troca o título a cada segundo

            localStorage.setItem("showedLastTimeIdleness", Date.now());
        }
    }

    [
        "keyup",
        "touchmove" in window ? "touchmove" : "mousemove",
        "onwheel" in document.createElement("div")
            ? "wheel"
            : document.onmousewheel !== undefined
            ? "mousewheel"
            : "DOMMouseScroll",
    ].forEach(function (ev) {
        window.addEventListener(ev, actividade);
    });


    document.querySelectorAll('.btn-env').forEach(btn => {
        btn.addEventListener('click', () => document.querySelector('.loading')
        .classList.add('active'))})

    document.querySelector('#modal-abandono .close-modal')
        .addEventListener('click', () => document.querySelector('#modal-abandono')
        .classList.remove('show'))
}


